module.exports = __webpack_public_path__ + "img/ASC.f5db6ba5.svg";